/**
 *  @ngdoc service
 *  @name adjust.service:customSelectParse
 *  @description
 *  Parses "repeat" attribute on custom-select directive.
 *
 *  Taken from AngularJS ngRepeat source code
 *  See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L211
 *
 *  Its been used to provide a flexible api that can parse any expression passed to the directive
 *  and can be used as angular ng-repeat
 */
function customSelectParse($parse) {
  'ngInject';
  return {
    parse: parse,
  };

  /**
   * @ngdoc method
   * @name parse
   * @methodOf adjust.service:customSelectParse
   *
   * @description
   * parses the expression provided to it similar to ng-repeat
   *
   * @param {String} expression expression to be parsed
   * @example
   * expression = "address in addresses | filter: {street: $select.search} track by $index"
   * itemName = "address",
   * source = "addresses | filter: {street: $select.search}",
   * trackByExp = "$index",
   */
  function parse(expression) {
    var match;

    // eslint-disable-next-line no-useless-escape
    match = expression.match(/^\s*(?:([\s\S]+?)\s+as\s+)?(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(\s*[\s\S]+?)?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

    // 1 Alias
    // 2 Item
    // 3 Key on (key,value)
    // 4 Value on (key,value)
    // 5 Source expression (including filters)
    // 6 Track by

    if (!match) {
      throw "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.";
    }

    var [, isAliased, secondaryName, keyName, primaryName, source, trackByExp] = match;

    return {
      itemName: primaryName || secondaryName, // (lhs) Left-hand side,
      keyName: keyName, // for (key, value) syntax
      source: $parse(source),
      isAliased: !!isAliased, // checks for as syntax
      trackByExp: trackByExp,
      modelMapper: $parse(isAliased || primaryName || secondaryName),
      repeatExpression: function() {
        var expression = this.itemName + ' in $select.options';
        if (this.trackByExp) {
          expression += ' track by ' + this.trackByExp;
        }
        return expression;
      },
    };
  }
}
export { customSelectParse };
